// import '../Scss/Frontend/Elements/Login.scss';
import $ from 'jquery';

let $modal = $('#loginModal'),
	$register = $modal.find('.register'),
	$spinner = $modal.find('.spinner-overlay'),
	urlPath = $modal.find('[name="url"]').val(),
	loginSuccess = $modal.find('[name="loginSuccess"]').val(),
	originalForm = true;

if (location.hash === '#loginModal') {
	$modal.modal('show');
}

function submit(url, data = []) {
	originalForm = false;
	data.push({name: 'type', value: 1580999567});
	data.push({name: 'tx_felogin_pi1[noredirect]', value: 1});
	return $.ajax({
		url: url,
		method: 'post',
		data: $.param(data)
	});
}

$modal.on('submit', 'form', function () {
	let data = $(this).serializeArray();
	data.push({name: 'redirect_url', value: location.href});

	$spinner.removeClass('d-none');
	let url = this.action;
	if(originalForm) {
		url = urlPath;
	}
	submit(url, data).then(data => {
		let status = $(data).find('.status').html();
		let flashmessages = $(data).find('.flashmessages').html();

		if ($(data).find('form').length) {
			if(!flashmessages) {
				replaceContent(data, '.status');

				$modal
					.find('.status')
					.html(status)
					.addClass('alert alert-danger mt-3');
				$spinner.addClass('d-none');
				
			} else {
				replaceContent(data);
			}
		} else if(data.indexOf(loginSuccess) !== -1) {
			replaceContent(data);
			$register.addClass('d-none');
			if(location.search.length !== 0) {
				location.href = location.pathname;
			} else {
				location.reload();
			}
		}
		else {
			replaceContent(data);
		}
	}).fail(data => {
		$modal
			.find('.status')
			.html($modal.find('input[name=error]').val())
			.addClass('alert alert-danger');
		$spinner.addClass('d-none');

	});
	return false;
});

function replaceContent(data, selector = '.tx-felogin-pi1') {
	$modal.find(selector).html(
		$(data).find(selector).html()
	);
	$spinner.addClass('d-none');
}

$modal.on('click', '.forgot-password a', function() {
	let url = new URL(this.href);
	url.pathname = urlPath;
	submit(url).then(data => {
		replaceContent(data);
	});
	return false;
}).on('click', '.back a', function() {
	submit(this.href).then(data => {
		replaceContent(data);
	});
	return false;
})
